<template>
	<div class="home">
		<!-- The landing video banner -->
		<VideoBanner
			:webm-src="{ mobile: require(`@/assets/videos/Homepage_mobile.webm`), desktop: require(`@/assets/videos/Homepage_desktop.webm`) }"
			:mp4-src="{ mobile: require(`@/assets/videos/Homepage_mobile.mp4`), desktop: require(`@/assets/videos/Homepage_desktop.mp4`) }"
			title="Discovery Awaits<sup>™</sup>"
			button-text="View Products"
			:route="{ name: 'products' }"
			data-cy="home-banner-video"
			data-cy-content="banner-video-content"
		/>

		<!-- The featured Products -->
		<FeaturedProducts />
	</div>
</template>

<script>
import FeaturedProducts from '@/components/shared/FeaturedProducts';
import VideoBanner from '@/components/shared/VideoBanner';
export default {
	components: {
		FeaturedProducts,
		VideoBanner
	}
};
</script>

<style lang="scss" scoped></style>
